module.exports = __webpack_public_path__ + "static/img/7.04a8d2bd.png";